import { z } from 'zod';
import { isValidPhoneAU } from '@workspace/lib/helper';

export const contactFormSchema = z.object({
  firstname: z.string().min(1, 'This field is required.').max(50, 'First name is limited to 50 characters.'),
  lastname: z.string().min(1, 'This field is required.').max(50, 'Last name is limited to 50 characters.'),
  email: z
    .string()
    .min(1, 'This field is required.')
    .email('Invalid email format. Example: name@example.com.')
    .max(255, 'Email is limited to 255 characters.'),
  phone: z
    .string()
    .min(1, 'This field is required.')
    .refine((v) => isValidPhoneAU(String(v || '')), {
      message: 'Invalid phone number.',
    }),
  company: z.string().max(255, 'Company Name is limited to 255 characters.').optional(),
  state: z.string().min(1, 'This field is required.'),
  area_of_work: z.string().min(1, 'This field is required.'),
  where_did_you_hear_about_porta_: z.string().optional(),
  enquiry_type___dropdown: z.string().min(1, 'This field is required.'),
  message: z.string().min(1, 'This field is required.').max(1000, 'Message is limited to 1000 characters.'),
  newsletter: z.boolean().default(false),
  honeypot: z.string().optional(),
});

export type ContactFormData = z.infer<typeof contactFormSchema>;
